import { createFileRoute, redirect } from "@tanstack/react-router"

export const Route = createFileRoute("/_auth/forecasting/_layout")({
  beforeLoad: () => {
    throw redirect({ to: "/demand-planning" })
  },
})
